import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { DeleteExtractTasksAction } from '../../../../extract/services/DeleteExtractTasksAction';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { DeleteExtractRefreshAction } from '../../../actions/spaces/DeleteExtractRefreshAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';

export function* handleDeleteExtractRefreshAction(action: DeleteExtractRefreshAction) {
  try {
    yield call(executeDeleteExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteExtractRefreshAction(items: IExtractTaskInfo[]) {
  return DeleteExtractTasksAction.executeWithContext(Set.fromIdItemArray(items));
}
